import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

export const AboutUs = () => {

    return (
        <div className="AboutUs-Page">
            {/* Breadcrumb Banner Section */}
            <section className="breadcrumb-banner-section py-5">
                <div className="container-xl position-relative z-1">
                    <div className="page-header text-white text-uppercase text-center">
                        <div className="section-heading text-white lh-sm mb-2">About Us</div>
                        <ul className="list-unstyled d-flex justify-content-center gap-2 mb-0">
                            <li className="text-white">Home</li>
                            <li>
                                <span>/</span>
                            </li>
                            <li className="text-primary">About</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* About Us Section */}
            <section className="about-cmpny-sec bg-secondary bg-opacity-10 py-5">
                <div className="container-xl my-md-4">
                    <Row className="align-items-center gx-md-5 gy-4">
                        <Col lg={6}>
                            <div data-aos="slide-right" className="img-wrapper position-relative">
                                <img src={require('../assets/images/about-image-3.jpg')} className="img-fluid w-100" alt="About" />
                                <div className="img-frame position-absolute top-50 start-50 translate-middle z-1"></div>
                            </div>
                        </Col>
                        <Col lg={6}>
                            <div data-aos="slide-left" className="content-wrapper">
                                <div className="label-heading mb-2"><span className="badge bg-success fw-semibold">About Us</span></div>
                                <div className="section-heading mb-3">Empowering <span>learners</span> to speak <span>languages</span> confidently.</div>
                                <div className="our-mission-wrapper mb-4">
                                    <p>
                                        Yoospeak was created by Youssel Calisme, Founder and Owner of the platform, after nearly 11 years of teaching and helping thousands of students build confidence through communication.
                                    </p>
                                    <p>
                                        Fluent in English, French, Spanish, and Haitian Creole, Youssel has spent years connecting with people from different cultures and backgrounds. Throughout his teaching career, he realized that one of the biggest challenges language learners face is finding enough opportunities to practice speaking in real-life situations. Learning vocabulary and grammar is important, but consistent conversation is what truly builds confidence and fluency.
                                    </p>
                                    <p>
                                        With that vision in mind, Yoospeak was developed to make language learning more accessible, practical, and engaging. The platform allows learners to practice with real people from around the world while also giving them the opportunity to practice with AI, making it possible to improve their communication skills anytime, anywhere.
                                    </p>
                                    <p>
                                        Although Youssel’s teaching experience began with English, his vision for Yoospeak has always been much bigger. He created the platform to help people learn, practice, and communicate in languages from around the world, bringing together learners from different countries, cultures, and communities in one place.
                                    </p>
                                    <p>
                                        Built on years of teaching experience and a passion for languages, Yoospeak is designed to help learners gain confidence, improve pronunciation, strengthen conversation skills, and communicate naturally in everyday life—regardless of the language they choose to learn.
                                    </p>
                                </div>
                                <div className="btn-wrapper mt-4">
                                    <button type="button" className="btn-custom btn btn-theme1">Learn More <i className="bi bi-arrow-right"></i></button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* What is Yoospeak Section */}
            <section className="about-cmpny-sec py-5">
                <div className="container-xl my-md-4">
                    <div className="section-heading-wrapper">
                        <div className="section-heading">What is <span>Yoospeak?</span></div>
                        <div className="description">Yoospeak is a language learning app designed to help students succeed at work, in interviews, and in daily life.</div>
                    </div>
                    <Row className="g-4">
                        <Col md={6} lg={4}>
                            <div data-aos="slide-right" className="item-wrapper h-100 bg-theme1 bg-opacity-25 border border-theme1 rounded-4 text-center px-4 py-5">
                                <div className="icon mb-4">
                                    <img src={require('../assets/images/mission.png')} alt="Mission" className="img-fluid" />
                                </div>
                                <div className="fs-4 fw-semibold text-dark mb-2">Mission</div>
                                <div className="fs-6 text-body text-opacity-75">At Yoospeak, our mission is to make language learning easier, more interactive, and accessible to everyone by combining real conversations, innovative technology, and a global community of language learners.</div>
                            </div>
                        </Col>

                        <Col md={6} lg={4}>
                            <div data-aos="zoom-in-up" className="item-wrapper h-100 bg-success bg-opacity-25 border border-success rounded-4 text-center px-4 py-5">
                                <div className="icon mb-4">
                                    <img src={require('../assets/images/vision.png')} alt="Vision" className="img-fluid" />
                                </div>
                                <div className="fs-4 fw-semibold text-dark mb-2">Vision</div>
                                <div className="fs-6 text-body text-opacity-75">Our vision is to empower learners everywhere to communicate confidently and become part of a global language-learning community.</div>
                            </div>
                        </Col>

                        <Col md={6} lg={4}>
                            <div data-aos="slide-left" className="item-wrapper h-100 bg-danger bg-opacity-25 border border-danger rounded-4 text-center px-4 py-5">
                                <div className="icon mb-4">
                                    <img src={require('../assets/images/teacher.png')} alt="Teacher" className="img-fluid" />
                                </div>
                                <div className="fs-4 fw-semibold text-dark mb-2">Teachers</div>
                                <div className="fs-6 text-body text-opacity-75">Yoospeak connects learners with skilled and passionate language teachers, providing guidance, feedback, and personalized support to help every student succeed.</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Our Team Section */}
            <section className="our-team-sec bg-primary bg-opacity-10 py-5">
                <div className="container-xl my-md-4">
                    <div className="section-heading-wrapper pb-md-3">
                        <div className="section-heading">Meet The <span>Expert</span></div>
                        <div className="description">Leaders, innovators, and professionals dedicated to shaping the future.</div>
                    </div>
                    <Row className="justify-content-center">
                        <Col lg={4} md={6}>
                            <div data-aos="zoom-in" className="team-wrapper text-center">
                                <div className="img-wrapper position-relative p-3 p-md-4">
                                    <img src={require('../assets/images/team5.png')} className="img-fluid" alt="Team Member" />
                                </div>
                                <div className="team-info text-center mt-3">
                                    <div className="name text-lg fw-semibold text-black mb-1">Teacher Yoos</div>
                                    <div className="designation small text-muted mb-2">Certified ESL Teacher / Certified Medical Interpreter</div>
                                    <div className="social-wrapper d-flex align-items-center justify-content-center gap-3 mt-2">
                                        <Link to="https://www.facebook.com/share/1JHpbbwrre/?mibextid=wwXIfr" className="text-base text-primary"><i className="bi bi-facebook"></i></Link>
                                        <Link to="https://twitter.com/" className="text-base text-primary"><i className="bi bi-twitter"></i></Link>
                                        <Link to="https://www.instagram.com/" className="text-base text-primary"><i className="bi bi-instagram"></i></Link>
                                        <Link to="https://in.linkedin.com/" className="text-base text-primary"><i className="bi bi-linkedin"></i></Link>
                                        <Link to="https://www.tiktok.com/@yoospeak?_r=1&_t=ZT-9871f4wdYOE" className="text-base text-primary"><i className="bi bi-tiktok"></i></Link>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>

            {/* Practice Together Section */}
            <section className="practice-together-section d-flex align-items-center overlay-wrapper py-5">
                <div className="container-xl my-4">
                    <div data-aos="zoom-in-up" className="content-wrapper position-relative text-center mx-auto" style={{ maxWidth: '750px' }}>
                        <div className="section-heading-wrapper mb-4">
                            <div className="section-heading text-white text-uppercase mb-3">Practice <span>Together</span>, Learn <span>Together</span></div>
                            <div className="description fs-6 text-white text-opacity-75 mb-4">Join a global community of learners and teachers, improving language skills through interactive lessons, real-life practice, and shared growth.</div>
                        </div>
                        <div className="wrapper">
                            <div className="fs-5 fw-semibold text-white mb-3">Download Yoospeak App Now -</div>
                            <div className="app-btn-wrapper d-flex flex-wrap justify-content-center gap-3">
                                <Link className="text-md-end" to={'https://play.google.com/store/apps/details?id=com.yoospeak.learning'} target="_blank">
                                    <img src={require('../assets/images/play-store.png')} className="img-fluid rounded-3" alt='Google Play Store' />
                                </Link>
                                <Link to={'https://apps.apple.com/in/app/yoospeak/id6746839854'} target="_blank">
                                    <img src={require('../assets/images/app-store.png')} className="img-fluid rounded-3" alt='App Store' />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}
